import type { RouteListItem } from '@/types';

import { type InventoryBinLocationFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<InventoryBinLocationFormSchema> = {
  id: -1,
  location: '',
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/inventory-bin-locations', name: 'Bin Locations' },
];
